import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLines2 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 255,
	height: 16,
	viewBox: "0 0 255 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.14744 11.2738C46.1807 -2.46241 297.465 4.51789 244.812 6.02485C192.159 7.53181 156.171 6.39426 121.803 12.8801",
		stroke: "#FFC14A",
		strokeWidth: 5,
		strokeLinecap: "round"
	})
});
export default SvgLines2;
